var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlossaryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e1ecef;}.b{fill:#fff;}.c{fill:#1d9ebd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-749 -1690)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    transform: "translate(749 1690)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.4,0l6.7,13.5,14.8,2.1L32.2,26.1l2.5,14.8-13.3-7-13.2,7,2.5-14.8L0,15.6l14.8-2.1Z",
    transform: "translate(778.091 1714.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.474,0l3.279,6.607L21,7.635,15.76,12.774l1.224,7.244-6.51-3.426L4.013,20.018l1.224-7.244L0,7.635,7.244,6.607Z",
    transform: "translate(814.091 1755.988)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossaryIcon);
export default __webpack_public_path__ + "static/media/glossary-icon.2e3c3f873dad5463e7eb08b69a997d3b.svg";
export { ForwardRef as ReactComponent };